module.exports = __webpack_public_path__ + "img/comercio-microilustracion-typ.09f948ba.svg";